import React from 'react';

import { Bar, BarItem, Button, Select, Icon } from 'up-design-system-gex';

const countOptions = [
  { text: '10', value: "10" },
  { text: '25', value: "25" },
  { text: '50', value: "50" },
];

export default class TablePagination extends React.Component {
  render() {
    return (
      <Bar align="middle">
        <BarItem>
          <Select
            transparent
            defaultValue={this.props.rowsPerPage}
            size="small"
            id="count-on-page"
            options={countOptions}
            onChange={(val) => { this.props.handleRowsChange(val.value) }}
          />
        </BarItem>
        <BarItem isFilling />
        <BarItem>
          {this.props.currentPage > 1 &&
            <Button equal size="small">
              <Icon size="medium" name="chevron-left" onClick={() => { this.props.handlePageChange(this.props.currentPage - 1) }} />
            </Button>
          }
        </BarItem>
        <BarItem>
          stránka {this.props.currentPage} / {this.props.totalPages}
        </BarItem>
        <BarItem>
          {this.props.currentPage < this.props.totalPages &&
            <Button equal size="small">
              <Icon size="medium" name="chevron-right" onClick={() => { this.props.handlePageChange(this.props.currentPage + 1) }} />
            </Button>
          }
        </BarItem>
      </Bar>)
  }
}